import { ArticleParagraph1 } from '@cian/ui-kit';

import { FC } from 'react';

import { IOperatorDescriptionProps } from './types';

export const OperatorDescription: FC<IOperatorDescriptionProps> = props => {
  const { phoneNumber } = props;

  return (
    <>
      <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
        Оператор коворкинга свяжется с вами в рабочее время
      </ArticleParagraph1>
      {phoneNumber && (
        <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
          по номеру {phoneNumber}
        </ArticleParagraph1>
      )}
    </>
  );
};

OperatorDescription.displayName = 'OperatorDescription';
